module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    attrs: {
      "id": "app"
    }
  }, [(_vm.app_show) ? _c('div', {}) : _vm._e(), _vm._v(" "), (_vm.showcompon) ? _c('div', [_c('Navigahome', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispute),
      expression: "!dispute"
    }],
    ref: "nav",
    attrs: {
      "isActive": _vm.isActive
    },
    on: {
      "clicfun": _vm.clicfun
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.app.is_show) ? _c('base-crumbs', {
    attrs: {
      "crumbs": []
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "height"
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.showcompon) ? _c('div', [_c('Footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispute),
      expression: "!dispute"
    }]
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showcompon) ? _c('div', [_c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispute),
      expression: "!dispute"
    }]
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showcompon) ? _c('div', [_c('right', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispute),
      expression: "!dispute"
    }]
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f5514b22!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 957
// module chunks = 42